import colorsOptions from '../../fundamentals/colors-styles/constants'
import {
  textStyleSizeOptions,
  textStyleSizeStyleOptions
} from '../../fundamentals/text-styles/constants'

const progressBarVariantOptions = {
  DEFAULT: 'default',
  PROCESSING: 'processing',
  ERROR: 'error',
  COMPLETE: 'complete',
  PRIMARY: 'primary',
  WAITING: 'waiting'
}

const progressBarSizeOptions = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
}

const progressBarStyleOptions = {
  [progressBarSizeOptions.SMALL]: {
    bar: {
      height: '2px'
    },
    text: {
      ...textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]
    }
  },
  [progressBarSizeOptions.MEDIUM]: {
    bar: {
      height: '4px'
    },
    text: {
      ...textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]
    }
  },
  [progressBarSizeOptions.LARGE]: {
    bar: {
      height: '6px'
    },
    text: {
      ...textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-L']]
    }
  }
}

const progressBarColorOptions = {
  [progressBarVariantOptions.DEFAULT]: colorsOptions.greys['grey-70'],
  [progressBarVariantOptions.PRIMARY]:
    colorsOptions.secondaryColors.orange.strong,
  [progressBarVariantOptions.PROCESSING]: colorsOptions.semantics.info.strong,
  [progressBarVariantOptions.ERROR]: colorsOptions.semantics.danger['error-50'],
  [progressBarVariantOptions.COMPLETE]: colorsOptions.semantics.success.strong,
  [progressBarVariantOptions.WAITING]: colorsOptions.greys['grey-40']
}

const progressBarLabelOptions = {
  [progressBarVariantOptions.PROCESSING]: 'Processing...',
  [progressBarVariantOptions.ERROR]: 'Error',
  [progressBarVariantOptions.COMPLETE]: 'Complete',
  [progressBarVariantOptions.PRIMARY]: 'Processing...',
  [progressBarVariantOptions.WAITING]: 'Waiting...'
}

export {
  progressBarVariantOptions,
  progressBarSizeOptions,
  progressBarStyleOptions,
  progressBarColorOptions,
  progressBarLabelOptions
}
